// Here all available mutation types are stored to easily find them

// ./modules/auth
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM'
export const SET_ROLE = 'SET_ROLE'
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED'
export const SET_USER_AVATAR = 'SET_USER_AVATAR'
export const LOGOUT = 'LOGOUT'
export const SET_CREDENTIALS = 'SET_CREDENTIALS'
export const SET_2FA = 'SET_2FA'
export const SET_MATOMO_USER_ID = 'SET_MATOMO_USER_ID'

// ./modules/team
export const SET_TEAMS = 'SET_TEAMS'
export const SET_TEAM = 'SET_TEAM'
export const ADD_TEAM = 'ADD_TEAM'
export const UPDATE_TEAM = 'UPDATE_TEAM'
export const UPDATE_TEAM_MEMBER = 'UPDATE_TEAM_MEMBER'
export const REMOVE_TEAM_MEMBER = 'REMOVE_TEAM_MEMBER'
export const REMOVE_TEAM = 'REMOVE_TEAM'
export const CREATE_TEAM_INVITATION = 'CREATE_TEAM_INVITATION'
export const REMOVE_TEAM_INVITATION = 'REMOVE_TEAM_INVITATION'
export const SET_TEAM_LOGO = 'SET_TEAM_LOGO'
export const SET_TEAM_WATERMARK = 'SET_TEAM_WATERMARK'
export const UPDATE_TEAM_ADDRESS = 'UPDATE_TEAM_ADDRESS'
export const UPDATE_TEAM_EMAIL_ADDRESS = 'UPDATE_TEAM_EMAIL_ADDRESS'
export const UPDATE_TEAM_PHONE_NUMBER = 'UPDATE_TEAM_PHONE_NUMBER'
export const UPDATE_TEAM_BANK_DETAILS = 'UPDATE_TEAM_BANK_DETAILS'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'
export const SET_SUBSCRIPTION_STATUS = 'SET_SUBSCRIPTION_STATUS'
export const SET_TEAM_SETTINGS = 'SET_TEAM_SETTINGS'

// ./modules/persons
export const REMOVE_PERSON = 'REMOVE_PERSON'

// ./modules/customers
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_CUSTOMERS_META = 'SET_CUSTOMERS_META'
export const SET_CUSTOMERS_LOADED = 'SET_CUSTOMERS_LOADED'
export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER'
export const ADD_CHECKED_CUSTOMER = 'ADD_CHECKED_CUSTOMER'
export const ADD_CUSTOMER = 'ADD_CUSTOMER'
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const REMOVE_CUSTOMER = 'REMOVE_CUSTOMER'
export const REMOVE_CUSTOMERS = 'REMOVE_CUSTOMERS'
export const REMOVE_CHECKED_CUSTOMER = 'REMOVE_CHECKED_CUSTOMER'
export const CLEAR_CHECKED_CUSTOMERS = 'CLEAR_CHECKED_CUSTOMERS'
export const CREATE_CUSTOMER_ADDRESS = 'CREATE_CUSTOMER_ADDRESS'
export const UPDATE_CUSTOMER_ADDRESS = 'UPDATE_CUSTOMER_ADDRESS'
export const REMOVE_CUSTOMER_ADDRESS = 'REMOVE_CUSTOMER_ADDRESS'
export const CREATE_CUSTOMER_EMAIL_ADDRESS = 'CREATE_CUSTOMER_EMAIL_ADDRESS'
export const UPDATE_CUSTOMER_EMAIL_ADDRESS = 'UPDATE_CUSTOMER_EMAIL_ADDRESS'
export const REMOVE_CUSTOMER_EMAIL_ADDRESS = 'REMOVE_CUSTOMER_EMAIL_ADDRESS'
export const CREATE_CUSTOMER_PHONE_NUMBER = 'CREATE_CUSTOMER_PHONE_NUMBER'
export const UPDATE_CUSTOMER_PHONE_NUMBER = 'UPDATE_CUSTOMER_PHONE_NUMBER'
export const REMOVE_CUSTOMER_PHONE_NUMBER = 'REMOVE_CUSTOMER_PHONE_NUMBER'
export const CREATE_CUSTOMER_NOTE = 'CREATE_CUSTOMER_NOTE'
export const UPDATE_CUSTOMER_NOTE = 'UPDATE_CUSTOMER_NOTE'
export const REMOVE_CUSTOMER_NOTE = 'REMOVE_CUSTOMER_NOTE'
export const CREATE_CUSTOMER_BANK_DETAILS = 'CREATE_CUSTOMER_BANK_DETAILS'
export const UPDATE_CUSTOMER_BANK_DETAILS = 'UPDATE_CUSTOMER_BANK_DETAILS'
export const REMOVE_CUSTOMER_BANK_DETAILS = 'REMOVE_CUSTOMER_BANK_DETAILS'
export const SET_CUSTOMERS_FILTER = 'SET_CUSTOMERS_FILTER'
export const OPEN_EDIT_CUSTOMER_MODAL = 'OPEN_EDIT_CUSTOMER_MODAL'
export const SET_EXPORT_MODAL_STATUS = 'SET_EXPORT_MODAL_STATUS'
export const ADD_CONTACT_PERSON = 'ADD_CONTACT_PERSON'
export const UPDATE_CONTACT_PERSON = 'UPDATE_CONTACT_PERSON'
export const REMOVE_CONTACT_PERSON = 'REMOVE_CONTACT_PERSON'

// ./modules/companies
export const REMOVE_COMPANY = 'REMOVE_COMPANY'

// ./modules/items
export const SET_ITEMS = 'SET_ITEMS'
export const SET_ITEMS_META = 'SET_ITEMS_META'
export const SET_ITEMS_LOADED = 'SET_ITEMS_LOADED'
export const SET_SELECTED_ITEM = 'SET_SELECTED_ITEM'
export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const REMOVE_ITEM = 'REMOVE_ITEM'

// ./modules/statistics
export const SET_STATISTICS = 'SET_STATISTICS'
export const SET_STATISTICS_LOADED = 'SET_STATISTICS_LOADED'
export const SET_REVENUE_AVERAGE_YEAR = 'SET_REVENUE_AVERAGE_YEAR'
export const SET_EXPENSES_AVERAGE_YEAR = 'SET_EXPENSES_AVERAGE_YEAR'

// ./modules/invoices
export const SET_INVOICES = 'SET_INVOICES'
export const SET_INVOICES_META = 'SET_INVOICES_META'
export const SET_INVOICES_LOADED = 'SET_INVOICES_LOADED'
export const ADD_INVOICE = 'ADD_INVOICE'
export const REMOVE_INVOICE = 'REMOVE_INVOICE'
export const UPDATE_INVOICE = 'UPDATE_INVOICE'

// ./modules/invoiceTextTemplates
export const ADD_INVOICE_TEXT_TEMPLATE = 'ADD_INVOICE_TEXT_TEMPLATE'
export const SET_INVOICE_TEXT_TEMPLATES = 'SET_INVOICE_TEXT_TEMPLATES'
export const SET_INVOICE_TEXT_TEMPLATES_META = 'SET_INVOICE_TEXT_TEMPLATES_META'
export const SET_INVOICE_TEXT_TEMPLATES_LOADED = 'SET_INVOICE_TEXT_TEMPLATES_LOADED'
export const REMOVE_INVOICE_TEXT_TEMPLATE = 'REMOVE_INVOICE_TEXT_TEMPLATE'
export const UPDATE_INVOICE_TEXT_TEMPLATE = 'UPDATE_INVOICE_TEXT_TEMPLATE'

// ./modules/quoteTextTemplates
export const ADD_QUOTE_TEXT_TEMPLATE = 'ADD_QUOTE_TEXT_TEMPLATE'
export const SET_QUOTE_TEXT_TEMPLATES = 'SET_QUOTE_TEXT_TEMPLATES'
export const SET_QUOTE_TEXT_TEMPLATES_META = 'SET_QUOTE_TEXT_TEMPLATES_META'
export const SET_QUOTE_TEXT_TEMPLATES_LOADED = 'SET_QUOTE_TEXT_TEMPLATES_LOADED'
export const REMOVE_QUOTE_TEXT_TEMPLATE = 'REMOVE_QUOTE_TEXT_TEMPLATE'
export const UPDATE_QUOTE_TEXT_TEMPLATE = 'UPDATE_QUOTE_TEXT_TEMPLATE'

// ./modules/quotes
export const SET_QUOTES = 'SET_QUOTES'
export const SET_QUOTES_META = 'SET_QUOTES_META'
export const SET_QUOTES_LOADED = 'SET_QUOTES_LOADED'
export const REMOVE_QUOTE = 'REMOVE_QUOTE'
export const UPDATE_QUOTE = 'UPDATE_QUOTE'

// ./modules/localSettings
export const SET_INVOICE_DISPLAY_TYPE = 'SET_INVOICE_DISPLAY_TYPE'
export const PERSIST_LOCAL_SETTINGS = 'PERSIST_LOCAL_SETTINGS'
export const SET_AUTO_GENERATE_INVOICE_NUMBER = 'SET_AUTO_GENERATE_INVOICE_NUMBER'
export const SET_AUTO_GENERATE_QUOTE_NUMBER = 'SET_AUTO_GENERATE_QUOTE_NUMBER'
export const SET_AUTO_GENERATE_CUSTOMER_NUMBER = 'SET_AUTO_GENERATE_CUSTOMER_NUMBER'
export const SET_LAST_SALES_TAX = 'SET_LAST_SALES_TAX'
export const SET_SHOW_DASHBOARD_REVENUE_AVERAGE = 'SET_SHOW_DASHBOARD_REVENUE_AVERAGE'
export const SET_SHOW_DASHBOARD_EXPENSES_AVERAGE = 'SET_SHOW_DASHBOARD_EXPENSES_AVERAGE'

// ./modules/activities
export const SET_ACTIVITIES = 'SET_ACTIVITIES'
export const SET_ACTIVITIES_META = 'SET_ACTIVITIES_META'
export const SET_ACTIVITIES_LOADED = 'SET_ACTIVITIES_LOADED'

// ./modules/timeEntries
export const SET_TIME_TRACKING_STATISTICS_LOADED = 'SET_TIME_TRACKING_STATISTICS_LOADED'
export const SET_TIME_TRACKING_STATISTICS = 'SET_TIME_TRACKING_STATISTICS'
export const SET_TIME_ENTRIES = 'SET_TIME_ENTRIES'
export const SET_TIME_ENTRIES_META = 'SET_TIME_ENTRIES_META'
export const SET_TIME_ENTRIES_LOADED = 'SET_TIME_ENTRIES_LOADED'
export const SET_ACTIVE_TIME_ENTRY = 'SET_ACTIVE_TIME_ENTRY'
export const ADD_TIME_ENTRY = 'ADD_TIME_ENTRY'
export const UPDATE_TIME_ENTRY = 'UPDATE_TIME_ENTRY'
export const REMOVE_TIME_ENTRY = 'REMOVE_TIME_ENTRY'

// ./modules/projects
export const SET_PROJECTS = 'SET_PROJECTS'
export const SET_PROJECTS_META = 'SET_PROJECTS_META'
export const SET_PROJECTS_LOADED = 'SET_PROJECTS_LOADED'
export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT'
export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const REMOVE_PROJECT = 'REMOVE_PROJECT'

// ./modules/expenses
export const SET_EXPENSES = 'SET_EXPENSES'
export const SET_EXPENSES_META = 'SET_EXPENSES_META'
export const SET_EXPENSES_LOADED = 'SET_EXPENSES_LOADED'
export const COMMIT_EXPENSE = 'COMMIT_EXPENSE'
export const DELETE_EXPENSE = 'DELETE_EXPENSE'

// ./modules/createInvoice
export const CREATE_INVOICE_SET_ITEMS = 'CREATE_INVOICE_SET_ITEMS'
export const CREATE_INVOICE_ADD_BLOCK = 'CREATE_INVOICE_ADD_BLOCK'
export const CREATE_INVOICE_DELETE_BLOCK = 'CREATE_INVOICE_DELETE_BLOCK'
export const CREATE_INVOICE_SET_ACTIVE_LINE_ITEM = 'CREATE_INVOICE_SET_ACTIVE_LINE_ITEM'
export const CREATE_INVOICE_UPDATE_ACTIVE_LINE_ITEM = 'CREATE_INVOICE_UPDATE_ACTIVE_LINE_ITEM'
export const CREATE_INVOICE_ADD_LINE_ITEM = 'CREATE_INVOICE_ADD_LINE_ITEM'
export const CREATE_INVOICE_DELETE_LINE_ITEM = 'CREATE_INVOICE_DELETE_ACTIVE_LINE_ITEM'
export const CREATE_INVOICE_SET_SHOW_ITEM_FORM = 'CREATE_INVOICE_SET_SHOW_ITEM_FORM'
export const CREATE_INVOICE_UPDATE_GROUP = 'CREATE_INVOICE_UPDATE_GROUP'
export const CREATE_INVOICE_UPDATE_GROUP_HEADING = 'CREATE_INVOICE_UPDATE_GROUP_HEADING'
export const CREATE_INVOICE_RESET = 'CREATE_INVOICE_RESET'

// ./modules/createQuote
export const CREATE_QUOTE_SET_ITEMS = 'CREATE_QUOTE_SET_ITEMS'
export const CREATE_QUOTE_ADD_BLOCK = 'CREATE_QUOTE_ADD_BLOCK'
export const CREATE_QUOTE_DELETE_BLOCK = 'CREATE_QUOTE_DELETE_BLOCK'
export const CREATE_QUOTE_SET_ACTIVE_LINE_ITEM = 'CREATE_QUOTE_SET_ACTIVE_LINE_ITEM'
export const CREATE_QUOTE_UPDATE_ACTIVE_LINE_ITEM = 'CREATE_QUOTE_UPDATE_ACTIVE_LINE_ITEM'
export const CREATE_QUOTE_ADD_LINE_ITEM = 'CREATE_QUOTE_ADD_LINE_ITEM'
export const CREATE_QUOTE_DELETE_LINE_ITEM = 'CREATE_QUOTE_DELETE_ACTIVE_LINE_ITEM'
export const CREATE_QUOTE_SET_SHOW_ITEM_FORM = 'CREATE_QUOTE_SET_SHOW_ITEM_FORM'
export const CREATE_QUOTE_UPDATE_GROUP = 'CREATE_QUOTE_UPDATE_GROUP'
export const CREATE_QUOTE_UPDATE_GROUP_HEADING = 'CREATE_QUOTE_UPDATE_GROUP_HEADING'
export const CREATE_QUOTE_RESET = 'CREATE_QUOTE_RESET'
